const T_PREFIX = "opportunities";

export const bannerTrns = {
  title: `${T_PREFIX}.banner.title`,
  description: `${T_PREFIX}.banner.description`,
  listOfPossibilitiesButton: `${T_PREFIX}.banner.list-of-possibilities-btn`,
};

export const revolutionizeApproachTrns = {
  title: `${T_PREFIX}.revolutionize-approach.title`,
  subtitle: `${T_PREFIX}.revolutionize-approach.subtitle`,
  paragraphFirst: `${T_PREFIX}.revolutionize-approach.description.paragraph-first`,
  paragraphSecond: `${T_PREFIX}.revolutionize-approach.description.paragraph-second`,
  paragraphThird: `${T_PREFIX}.revolutionize-approach.description.paragraph-third`,
  paragraphFourth: `${T_PREFIX}.revolutionize-approach.description.paragraph-fourth`,
};

export const buyerOpportunities = {
  quickStartOpportunityTitle: `${T_PREFIX}.buyer-opportunity.quick-start-title`,
  quickStartOpportunityDesc: `${T_PREFIX}.buyer-opportunity.quick-start-desc`,
  supportOpportunityTitle: `${T_PREFIX}.buyer-opportunity.support-title`,
  supportOpportunityDesc: `${T_PREFIX}.buyer-opportunity.support-desc`,
  riskMinimizationOpportunityTitle: `${T_PREFIX}.buyer-opportunity.risk-minimization-title`,
  riskMinimizationOpportunityDesc: `${T_PREFIX}.buyer-opportunity.risk-minimization-desc`,
  timeSavingsOpportunityTitle: `${T_PREFIX}.buyer-opportunity.time-savings-title`,
  timeSavingsOpportunityDesc: `${T_PREFIX}.buyer-opportunity.time-savings-desc`,
  expansionOpportunityTitle: `${T_PREFIX}.buyer-opportunity.expansion-title`,
  expansionOpportunityDesc: `${T_PREFIX}.buyer-opportunity.expansion-desc`,
  successOpportunityTitle: `${T_PREFIX}.buyer-opportunity.success-title`,
  successOpportunityDesc: `${T_PREFIX}.buyer-opportunity.success-desc`,
};

export const sellerOpportunities = {
  additionalIncomeOpportunityTitle: `${T_PREFIX}.seller-opportunity.additional-income-title`,
  additionalIncomeOpportunityDesc: `${T_PREFIX}.seller-opportunity.additional-income-desc`,
  brandExpansionOpportunityTitle: `${T_PREFIX}.seller-opportunity.brand-expansion-title`,
  brandExpansionOpportunityDesc: `${T_PREFIX}.seller-opportunity.brand-expansion-desc`,
  scalingOpportunityTitle: `${T_PREFIX}.seller-opportunity.scaling-title`,
  scalingOpportunityDesc: `${T_PREFIX}.seller-opportunity.scaling-desc`,
  collaborationOpportunityTitle: `${T_PREFIX}.seller-opportunity.collaboration-title`,
  collaborationOpportunityDesc: `${T_PREFIX}.seller-opportunity.collaboration-desc`,
  minimalRiskOpportunityTitle: `${T_PREFIX}.seller-opportunity.minimal-risk-title`,
  minimalRiskOpportunityDesc: `${T_PREFIX}.seller-opportunity.minimal-risk-desc`,
};

export const howItWorksTrns = {
  title: `${T_PREFIX}.how-it-works.title`,
  description: `${T_PREFIX}.how-it-works.description`,
  tableOfContent: `${T_PREFIX}.how-it-works.table-of-content`,
};

export const processStepsTrns = {
  searchAndSelectTitle: `${T_PREFIX}.process-steps.search-and-selects-title`,
  searchAndSelectUseFiltersSubtitle: `${T_PREFIX}.process-steps.search-and-selects-use-filters-subtitle`,
  searchAndSelectUseFiltersDesc: `${T_PREFIX}.process-steps.search-and-selects-use-filters-desc`,
  searchAndSelectReviewOffersSubtitle: `${T_PREFIX}.process-steps.search-and-selects-review-offers-subtitle`,
  searchAndSelectReviewOffersDesc: `${T_PREFIX}.process-steps.search-and-selects-review-offers-desc`,

  purchaseTitle: `${T_PREFIX}.process-steps.purchase-title`,
  purchaseClickSubtitle: `${T_PREFIX}.process-steps.purchase-click-subtitle`,
  purchaseClickDesc: `${T_PREFIX}.process-steps.purchase-click-desc`,

  agreementConclusionTitle: `${T_PREFIX}.process-steps.agreement-conclusion-title`,
  agreementConclusionDesc: `${T_PREFIX}.process-steps.agreement-conclusion-desc`,
  agreementConclusionPreliminarySubtitle: `${T_PREFIX}.process-steps.agreement-conclusion-preliminary-subtitle`,
  agreementConclusionPreliminaryDesc: `${T_PREFIX}.process-steps.agreement-conclusion-preliminary-desc`,
  agreementConclusionSigningSubtitle: `${T_PREFIX}.process-steps.agreement-conclusion-signing-subtitle`,
  agreementConclusionSigningDesc: `${T_PREFIX}.process-steps.agreement-conclusion-signing-desc`,
  agreementConclusionPaymentSubtitle: `${T_PREFIX}.process-steps.agreement-conclusion-payment-subtitle`,
  agreementConclusionPaymentDesc: `${T_PREFIX}.process-steps.agreement-conclusion-payment-desc`,
  agreementConclusionDocumentTransferSubtitle: `${T_PREFIX}.process-steps.agreement-conclusion-document-transfer-subtitle`,
  agreementConclusionDocumentTransferDesc: `${T_PREFIX}.process-steps.agreement-conclusion-document-transfer-desc`,

  completionTitle: `${T_PREFIX}.process-steps.completion-title`,
  completionConfirmationSubtitle: `${T_PREFIX}.process-steps.completion-confirmation-subtitle`,
  completionConfirmationDesc: `${T_PREFIX}.process-steps.completion-confirmation-desc`,
  completionBuyerSupportSubtitle: `${T_PREFIX}.process-steps.completion-buyer-support-subtitle`,
  completionBuyerSupportDesc: `${T_PREFIX}.process-steps.completion-buyer-support-desc`,

  businessLaunchTitle: `${T_PREFIX}.process-steps.business-launch-title`,
  businessLaunchImplementationSubtitle: `${T_PREFIX}.process-steps.business-launch-implementation-subtitle`,
  businessLaunchImplementationDesc: `${T_PREFIX}.process-steps.business-launch-implementation-desc`,
  businessLaunchScalingSubtitle: `${T_PREFIX}.process-steps.business-launch-scaling-subtitle`,
  businessLaunchScalingDesc: `${T_PREFIX}.process-steps.business-launch-scaling-desc`,
};

export const questionsAndAnswersTrns = {
  title: `${T_PREFIX}.questions-and-answers.title`,

  questionWhatBusinessClone: `${T_PREFIX}.questions-and-answers.question-what-business-clone`,
  answerWhatBusinessClone: `${T_PREFIX}.questions-and-answers.answer-what-business-clone`,

  questionHowRegister: `${T_PREFIX}.questions-and-answers.question-how-register`,
  answerHowRegister: `${T_PREFIX}.questions-and-answers.answer-how-register`,

  questionChooseBroker: `${T_PREFIX}.questions-and-answers.question-choose-broker`,
  answerChooseBroker: `${T_PREFIX}.questions-and-answers.answer-choose-broker`,

  questionProcessBuying: `${T_PREFIX}.questions-and-answers.question-process-buying`,
  answerProcessBuying: `${T_PREFIX}.questions-and-answers.answer-process-buying`,

  questionGuarantees: `${T_PREFIX}.questions-and-answers.question-guarantees`,
  answerGuarantees: `${T_PREFIX}.questions-and-answers.answer-guarantees`,

  questionBusinessValuation: `${T_PREFIX}.questions-and-answers.question-business-valuation`,
  answerBusinessValuation: `${T_PREFIX}.questions-and-answers.answer-business-valuation`,

  questionSupportAfterPurchase: `${T_PREFIX}.questions-and-answers.question-support-after-purchase`,
  answerSupportAfterPurchase: `${T_PREFIX}.questions-and-answers.answer-support-after-purchase`,

  questionDisputes: `${T_PREFIX}.questions-and-answers.question-disputes`,
  answerDisputes: `${T_PREFIX}.questions-and-answers.answer-disputes`,

  questionTransferAssets: `${T_PREFIX}.questions-and-answers.question-transfer-assets`,
  answerTransferAssets: `${T_PREFIX}.questions-and-answers.answer-transfer-assets`,

  questionPreliminaryAudit: `${T_PREFIX}.questions-and-answers.question-preliminary-audit`,
  answerPreliminaryAudit: `${T_PREFIX}.questions-and-answers.answer-preliminary-audit`,

  questionCosts: `${T_PREFIX}.questions-and-answers.question-costs`,
  answerCosts: `${T_PREFIX}.questions-and-answers.answer-costs`,

  questionSellMultipleCountries: `${T_PREFIX}.questions-and-answers.question-sell-multiple-countries`,
  answerSellMultipleCountries: `${T_PREFIX}.questions-and-answers.answer-sell-multiple-countries`,

  questionDataConfidentiality: `${T_PREFIX}.questions-and-answers.question-data-confidentiality`,
  answerDataConfidentiality: `${T_PREFIX}.questions-and-answers.answer-data-confidentiality`,

  questionBrokerServices: `${T_PREFIX}.questions-and-answers.question-broker-services`,
  answerBrokerServices: `${T_PREFIX}.questions-and-answers.answer-broker-services`,

  questionSuitableForRegion: `${T_PREFIX}.questions-and-answers.question-suitable-for-region`,
  answerSuitableForRegion: `${T_PREFIX}.questions-and-answers.answer-suitable-for-region`,

  questionSuccessGuarantees: `${T_PREFIX}.questions-and-answers.question-success-guarantees`,
  answerSuccessGuarantees: `${T_PREFIX}.questions-and-answers.answer-success-guarantees`,

  questionFinancialAssistance: `${T_PREFIX}.questions-and-answers.question-financial-assistance`,
  answerFinancialAssistance: `${T_PREFIX}.questions-and-answers.answer-financial-assistance`,

  questionLoanConditions: `${T_PREFIX}.questions-and-answers.question-loan-conditions`,
  answerLoanConditions: `${T_PREFIX}.questions-and-answers.answer-loan-conditions`,

  questionSubsidies: `${T_PREFIX}.questions-and-answers.question-subsidies`,
  answerSubsidies: `${T_PREFIX}.questions-and-answers.answer-subsidies`,

  questionGrants: `${T_PREFIX}.questions-and-answers.question-grants`,
  answerGrants: `${T_PREFIX}.questions-and-answers.answer-grants`,
};
